import moment from 'moment'

import { t } from '../../i18n'
import {
  BirthdateLabel,
  BirthdateText,
  InfoContainer,
  NameLabel,
  NameText,
  RowData,
} from './styles'

type UserInfoProps = {
  name: string
  birthdate: string
}

export const UserInfo = ({ name, birthdate }: UserInfoProps) => {
  return (
    <InfoContainer>
      <RowData>
        <NameLabel>{t('table.name')}</NameLabel>
        <NameText>{name}</NameText>
      </RowData>
      <RowData>
        <BirthdateLabel>{t('table.birthday')}</BirthdateLabel>
        <BirthdateText>
            {birthdate !== undefined && moment(birthdate).isValid()
                ? moment(birthdate).format('DD-MM-YYYY')
                : '-'}
        </BirthdateText>
      </RowData>
    </InfoContainer>
  )
}
